import { render, staticRenderFns } from "./TransferenciasPixEMV.vue?vue&type=template&id=62c10e47"
import script from "./TransferenciasPixEMV.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPixEMV.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPixEMV.vue?vue&type=style&index=0&id=62c10e47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports